// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1IGGY","buttons":"SendReceipts_buttons__2MHKp","email":"SendReceipts_email___srUG","bookApptTitle":"SendReceipts_bookApptTitle__xljTp"};